import React from "react";

const EditIcon = ({ className = "" }: { className?: string }) => {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        width="15"
        height="15"
        className={`${className}`}
      >
        <path d="M16.474 5.408l2.118 2.118" />
        <path d="M17.835 3.94a1.5 1.5 0 112.121 2.122L7.5 18.52 3 20l1.48-4.5L17.835 3.94z" />
      </svg>
    </>
  );
};

export default EditIcon;
